import axios from "axios";
import UserDataPopup from "components/UserData/UserDataPopup";
import { useEffect, useRef, useState } from "react";
import { BsChatSquareTextFill } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { useInView } from "react-intersection-observer";
import { useSearchParams } from "react-router-dom";
import Select from "react-select";
import { ClipLoader } from "react-spinners";
import { MdClose, MdOpenInNew } from "react-icons/md";
import { TiTickOutline } from "react-icons/ti";
import { toast, ToastContainer } from "react-toastify";
import { getToken } from "utils/getToken";
import {
  countBadge,
  fieldLabel,
  focusRing,
  ghostBtn,
  input as inputCls,
  pageKicker,
  pageTitle,
  primaryBtn,
  select as selectCls,
} from "components/ui/instrument";
import "../../assets/css/scrollBar.css";
import woman from "../../assets/img/avatars/woman.png";
import ChatBubble from "./ChatBubble";
import MultiSelect from "./MultiSelect";

function QNAs() {
  const [chatList, setChatList] = useState<any[]>([]);
  const [convo, setConvo] = useState<any[]>([]);
  const [listLoading, setlistLoading] = useState(false);
  const [convoLoading, setConvoLoading] = useState(false);
  const [activeChat, setActiveChat] = useState<any>(null);
  const [activeUser, setActiveUser] = useState("");
  const [isPDataModalOpen, setIsPDataModalOpen] = useState(false);
  const [selectedChatType, setSelectedChatType] = useState("");
  const [filter, setFilter] = useState({
    sort: "",
    type: "",
    doctor_id: "",
    end_date: "",
    start_date: "",
  });
  const [selectedDate, setSelectedDate] = useState({
    start_date: "",
    end_date: "",
  });
  const [doctorsData, setDoctorsData] = useState<any[]>([]);
  const [offset, setOffset] = useState<number | null>(0);
  const [totalMessages, setTotalMessages] = useState(0);
  const [doctorCareCount, setDoctorCareCount] = useState(0);
  const [followupCount, setFollowupCount] = useState(0);
  const [botCount, setBotCount] = useState(0);
  const [activeConvoId, setActiveConvoId] = useState<any>(null);
  const [statusParam] = useSearchParams();
  const param = statusParam.get("status");
  // Deep link from the Worklist P0 card: ?mobile=<digits>&conversation_id=<id>
  const mobileParam = (statusParam.get("mobile") ?? "").replace(/\D/g, "");
  const convoParam = statusParam.get("conversation_id");
  const [mobile, setMobile] = useState(mobileParam);
  const [conversationStatus, setConversationStatus] = useState("");
  const [initialArray, setInitialArray] = useState<string[]>(() => {
    return param === "actionable" ? [param] : [];
  });
  const [statusArray, setStatusArray] = useState<string[]>(() => {
    return param === "actionable" ? [param] : [];
  });
  const [statusSubsArray, setStatusSubsArray] = useState<string[]>([]);
  const [userMobile, setUserMobile] = useState("");

  const { ref, inView } = useInView({ threshold: 0.1 });

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${getToken()}`,
  };

  const selectClassName = selectCls;

  const statusFilterOptions = [
    { name: "Close", value: "close" },
    { name: "Doctor Pending", value: "doctor_pending" },
    { name: "Actionable", value: "actionable" },
    { name: "Replied", value: "replied" },
  ];

  const statusSubsFilterOptions = [
    { name: "BTP", value: "btp" },
    { name: "Holistic", value: "holistic" },
    { name: "Nurture (1 Month)", value: "nurture (1 month)" },
    { name: "Nurture (12 Months)", value: "nurture (12 months)" },
    { name: "Essential", value: "essential" },
  ];

  const chatTypeData = [
    { name: "All", value: "" },
    { name: "Doctor Care", value: "doctor_care" },
    { name: "Follow-up", value: "followup" },
    { name: "Bot", value: "qna" },
  ];

  if (filter.type === "" || filter.type === "qna") {
    statusFilterOptions.splice(1, 0, { name: "Open", value: "open" });
  }

  const getChatList = async (
    formattedMobile?: string | null,
    resetOffset?: number | null
  ) => {
    setlistLoading(true);
    try {
      const statusQuery = statusArray.join(",");
      const statusSubsQuery = statusSubsArray.join(",");
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `bot/support-portal/conversation/chat-list/?status=${statusQuery}&subs=${
            statusSubsQuery === "all" ? "" : statusSubsQuery
          }&sort=${filter.sort}&offset=${
            resetOffset === 0 ? 0 : offset
          }&mobile=${formattedMobile || ""}&type=${filter.type}&end_date=${
            filter.end_date
          }&start_date=${filter.start_date}&doctor_id=${filter.doctor_id}`,
        {
          headers,
        }
      );

      const responseCount = await axios.get(
        process.env.REACT_APP_API_URL +
          `bot/support-portal/conversation/count/pending/`,
        {
          headers,
        }
      );

      if (responseCount.status === 200) {
        setDoctorCareCount(responseCount.data.doctor_care.actionable);
        setFollowupCount(responseCount.data.followup.actionable);
        setBotCount(responseCount.data.qna.actionable);
      }

      if (response.status === 200) {
        setChatList((prev) => [...prev, ...response?.data?.messages]);
        setTotalMessages(response?.data?.totalMessages);
        setOffset(response?.data?.next_offset);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch chat list");
    } finally {
      setlistLoading(false);
    }
  };

  useEffect(() => {
    if (inView && offset !== null && !listLoading) {
      getChatList(mobile.replace(/[^\d+]/g, ""), offset);
    }
  }, [inView]);

  useEffect(() => {
    setOffset(0);
    setConvo([]);
    setActiveUser("");
    setActiveChat(null);
    setChatList([]);
    // carry a deep-linked phone number into the first fetch, so the list arrives
    // already scoped to that customer instead of being re-fetched a second time
    getChatList(mobile.length > 7 ? `+${mobile}` : null, 0);
  }, [filter, statusArray, statusSubsArray]);

  const getConvo = async (
    id: any,
    chatid: any,
    user_name: any,
    user_mobile?: any
  ) => {
    setConvoLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL +
          `bot/support-portal/conversation/messages/`,
        { conversation_id: id },
        {
          headers,
        }
      );
      if (response.status === 200) {
        setConvo(response?.data?.results);
        setActiveConvoId(id);
        setActiveChat(chatid);
        setActiveUser(user_name);
        setUserMobile(user_mobile);
        setConversationStatus(response?.data?.results[0]?.conversation_status);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch conversation");
    } finally {
      setConvoLoading(false);
    }
  };

  const handleFilterChange = ({
    target: { name, value },
  }: {
    target: { name: string; value: any };
  }) => {
    setOffset(0);
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChatTypeSelection = (value: string) => {
    setOffset(0);
    setFilter((prev) => ({
      ...prev,
      type: value,
    }));
    setSelectedChatType(value);
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOffset(0);
    const { name, value } = e.target;
    setSelectedDate((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setOffset(0);
    if (selectedDate.start_date && selectedDate.end_date) {
      setFilter((prev) => ({
        ...prev,
        start_date: selectedDate.start_date,
        end_date: selectedDate.end_date,
      }));
    }
  }, [selectedDate]);

  const handleStatusChange = (newSelectedStatuses: string[]) => {
    setOffset(0);
    setStatusArray(newSelectedStatuses);
  };
  const handleStatusSubsChange = (newSelectedStatuses: string[]) => {
    setOffset(0);
    setStatusSubsArray(newSelectedStatuses);
  };

  const fetchDoctors = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}doctors/doctors/all/`,
        {
          headers,
        }
      );
      setDoctorsData(data);
    } catch (error) {
      console.error("Error fetching doctors:", error);
      toast.error("Failed to fetch doctors");
    }
  };

  useEffect(() => {
    setOffset(0);
    fetchDoctors();
  }, []);

  const getFormattedDate = (dateISO: string) => {
    const date = new Date(dateISO);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${formattedDate} at ${formattedTime}`;
  };

  const handlePDataModal = () => {
    setIsPDataModalOpen(true);
  };
  const handlePDataModalClose = () => {
    setIsPDataModalOpen(false);
  };

  const handlePhSearch = () => {
    setChatList([]);
    const formattedMobile = `+${mobile}`;
    getChatList(formattedMobile, 0);
  };

  // Skip the first run: on mount the filter effect above already fetched with the
  // deep-linked mobile. Without this guard the two fetches race and double the list.
  const mobileSearched = useRef(false);
  useEffect(() => {
    if (!mobileSearched.current) {
      mobileSearched.current = true;
      return;
    }
    if (mobile !== "" && mobile.length > 7) {
      handlePhSearch();
    }
  }, [mobile]);

  // Auto-open the deep-linked thread once its chat row lands in the list.
  const autoOpened = useRef(false);
  useEffect(() => {
    if (autoOpened.current || !convoParam || chatList.length === 0) return;
    const target = chatList.find(
      (chat) => String(chat?.conversation_id) === convoParam
    );
    if (target) {
      autoOpened.current = true;
      getConvo(
        target.conversation_id,
        target?.id,
        target?.user_name,
        target?.user_mobile
      );
    }
  }, [chatList, convoParam]);

  const handlePhNoClear = () => {
    setChatList([]);
    setMobile("");
    getChatList(null, 0);
  };

  const scollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (scollRef.current) {
      scollRef.current.scrollTop = scollRef.current.scrollHeight;
    }
  }, [activeUser, activeChat, activeConvoId, offset]);

  const handleCloseChat = async (id: any) => {
    const data = {
      conversation_id: id,
      status: "replied",
    };
    const dataFinal = JSON.stringify(data);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}bot/user/conversation/status/update/`,
        dataFinal,
        { headers }
      );
      if (response.status === 200) {
        toast.success("Chat closed successfully.");
        setChatList([]);
        setMobile("");
        setOffset(0);
        getChatList(null, 0);
      }
    } catch (error) {
    }
  };

  const getIsClosedStatus = (id: any) => {
    const chat = chatList.find((chat) => chat.conversation_id === id);
    return chat?.status === "close";
  };

  return (
    <div className="relative h-[100vh] bg-white pt-2">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      {isPDataModalOpen && (
        <UserDataPopup
          selectedUser={userMobile}
          noSearch={true}
          handlePDataModalClose={handlePDataModalClose}
        />
      )}
      <div className="pl-1 pr-5">
        <div className="mb-3 flex items-end justify-between px-2">
          <div>
            <p className={pageKicker}>Babynama Clinic-OS</p>
            <h1 className={pageTitle}>Questions and Answers</h1>
          </div>
          <button
            className={ghostBtn}
            onClick={() => {
              setOffset(0);
              setMobile("");
              setChatList([]);
              getChatList(null, 0);
              activeConvoId !== null &&
                getConvo(activeConvoId, activeChat, activeUser);
            }}
          >
            Refresh
          </button>
        </div>

        {/* Filter rail: every control carries a micro-label — no more guessing
            which unlabeled dropdown does what. Labels only; behaviour untouched. */}
        <div className="flex flex-wrap items-end gap-3 px-2 pb-3">
          <div>
            <span className={fieldLabel}>Status</span>
            <MultiSelect
              filterOptions={statusFilterOptions}
              onChange={handleStatusChange}
              filterName="Status"
              preSelectedFilters={initialArray}
            />
          </div>
          <div>
            <span className={fieldLabel}>Subscription</span>
            <MultiSelect
              filterOptions={statusSubsFilterOptions}
              onChange={handleStatusSubsChange}
              filterName="Subscription"
            />
          </div>

          <label className="block">
            <span className={fieldLabel}>Sort</span>
            <select
              className={selectClassName}
              name="sort"
              onChange={handleFilterChange}
              value={filter.sort}
            >
              <option value="">Sort</option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
          </label>
          <label className="block">
            <span className={fieldLabel}>Doctor</span>
            <Select
              className="min-w-[200px] cursor-pointer text-sm"
              name="doctor_id"
              onChange={(selectedOption) =>
                handleFilterChange({
                  target: { name: "doctor_id", value: selectedOption?.value },
                })
              }
              value={
                doctorsData
                  .map((doctor) => ({ value: doctor.id, label: doctor.name }))
                  .find((option) => option.value === filter.doctor_id) || {
                  value: "",
                  label: "Find a doctor",
                }
              }
              options={[
                { value: "", label: "Select a doctor" },
                ...doctorsData.map((doctor) => ({
                  value: doctor.id,
                  label: doctor.name,
                })),
              ]}
              placeholder="Select a doctor"
              styles={{
                control: (base: any, state: any) => ({
                  ...base,
                  minHeight: "34px",
                  borderColor: "#cbd5e1",
                  boxShadow: state.isFocused ? "0 0 0 2px #0891b2" : "none",
                  "&:hover": {
                    borderColor: "#cbd5e1",
                  },
                }),
              }}
            />
          </label>

          <label className="block">
            <span className={fieldLabel}>Start date</span>
            <input
              type="date"
              className={`${selectClassName} tabular-nums`}
              name="start_date"
              onChange={handleDateChange}
              value={selectedDate.start_date}
            />
          </label>
          <label className="block">
            <span className={fieldLabel}>End date</span>
            <input
              type="date"
              className={`${selectClassName} tabular-nums`}
              name="end_date"
              onChange={handleDateChange}
              value={selectedDate.end_date}
            />
          </label>
        </div>
      </div>

      <div className="grid h-auto w-full grid-cols-12">
        <div className="col-span-4 flex h-[82vh] flex-col items-center border-t border-clinic-200">
          {/* Chat-type tabs. The count badge is the actionable backlog for that
              lane — neutral until non-zero, warning-tinted once there is work. */}
          <div
            role="tablist"
            aria-label="Chat type"
            className="flex w-full items-stretch border-b border-clinic-200"
          >
            {chatTypeData.map((chatType, i) => {
              const active = selectedChatType === chatType.value;
              const count =
                chatType.value === "doctor_care"
                  ? doctorCareCount
                  : chatType.value === "followup"
                  ? followupCount
                  : chatType.value === "qna"
                  ? botCount
                  : null;
              return (
                <button
                  key={i}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  onClick={() => handleChatTypeSelection(chatType.value)}
                  className={`flex w-1/4 items-center justify-center gap-1.5 border-b-2 px-1 py-3 text-[13px] transition-colors motion-reduce:transition-none ${focusRing} ${
                    active
                      ? "![border-bottom-color:#0e7490] font-semibold text-clinic-900"
                      : "border-transparent font-medium text-clinic-500 hover:text-clinic-900"
                  }`}
                >
                  {chatType.name}
                  {count !== null && (
                    <span
                      className={`${countBadge} ${
                        count > 0 ? "!bg-warn-100 !text-warn-700" : ""
                      }`}
                    >
                      {count}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
          <div className="flex w-full items-center gap-2 border-b border-clinic-100 py-2 px-2">
            <div className="relative flex-1">
              <input
                type="text"
                placeholder="Search by phone number"
                value={mobile}
                onChange={(e) => {
                  setMobile(e.target.value);
                }}
                className={`${inputCls} pr-9 tabular-nums`}
              />
              <button
                type="button"
                aria-label="Clear phone number"
                onClick={handlePhNoClear}
                className={`absolute right-2 top-1/2 -translate-y-1/2 rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
              >
                <MdClose className="h-5 w-5" />
              </button>
            </div>
            <button
              type="button"
              aria-label="Search"
              className={`${ghostBtn} shrink-0`}
              onClick={handlePhSearch}
            >
              <FaSearch className="h-4 w-4" />
            </button>
          </div>

          <div className="custom-scrollbar h-full w-full overflow-auto bg-white">
            {chatList.length > 0 &&
              chatList.map((msg, i) => {
                // One triage row per chat. Severity is the LEFT RAIL only:
                // actionable = warn amber, everything else neutral (the old
                // orange-100 full-row wash shouted on every actionable row).
                // Arbitrary border-left-color — plain border classes lose to
                // sibling border/divide rules in this theme.
                return (
                  <div
                    onClick={() =>
                      getConvo(
                        msg.conversation_id,
                        msg?.id,
                        msg?.user_name,
                        msg?.user_mobile
                      )
                    }
                    key={i}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getConvo(
                          msg.conversation_id,
                          msg?.id,
                          msg?.user_name,
                          msg?.user_mobile
                        );
                      }
                    }}
                    style={
                      activeChat === msg?.id
                        ? { backgroundColor: "#f1f5f9" }
                        : {}
                    }
                    className={`relative w-full cursor-pointer border-b border-clinic-100 border-l-4 px-3 py-2.5 transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-action-500 ${
                      msg?.is_actionable
                        ? "![border-left-color:#f59e0b] bg-warn-50 hover:bg-warn-100"
                        : "![border-left-color:transparent] bg-white hover:bg-clinic-50"
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <img
                        src={woman}
                        className="h-9 w-9 shrink-0"
                        alt=""
                        aria-hidden="true"
                      />
                      <div className="flex min-w-0 flex-1 flex-col gap-y-0.5">
                        <div className="flex items-baseline justify-between gap-2">
                          <p className="truncate text-sm font-semibold text-clinic-900">
                            {msg?.user_name}
                          </p>
                          <p className="shrink-0 text-[11px] tabular-nums text-clinic-400">
                            {getFormattedDate(msg?.updated_at)}
                          </p>
                        </div>
                        <div className="flex items-baseline justify-between gap-2">
                          <div className="flex min-w-0 items-baseline gap-x-1.5">
                            {msg?.last_msg?.content && (
                              <p className="truncate text-[13px] text-clinic-600">
                                {msg?.last_msg?.content?.length >= 16
                                  ? msg?.last_msg?.content?.slice(0, 16) + "..."
                                  : msg?.last_msg?.content}
                              </p>
                            )}
                            <p className="shrink-0 text-[11px] font-medium text-clinic-500">
                              {msg?.sender_type ? `— ${msg?.sender_type}` : ``}
                            </p>
                          </div>
                          <p className="shrink-0 text-[11px] font-medium text-clinic-500">
                            {msg?.doctor_name || ""}
                          </p>
                        </div>
                        <div className="mt-0.5 flex items-center gap-1.5">
                          <span className="rounded bg-clinic-100 px-1.5 py-px font-mono text-[9px] font-semibold uppercase tracking-[0.12em] text-clinic-600 ring-1 ring-clinic-200">
                            {msg?.type === "doctor_care"
                              ? "Doctor care"
                              : msg?.type === "followup"
                              ? "Follow up"
                              : msg?.type === "qna"
                              ? "Bot"
                              : ""}
                          </span>
                          {msg?.is_actionable && (
                            <span className="rounded bg-warn-100 px-1.5 py-px font-mono text-[9px] font-semibold uppercase tracking-[0.12em] text-warn-700 ring-1 ring-warn-200">
                              Actionable
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

            {/* Empty is a state of the list, in the list — not silence. */}
            {!listLoading && chatList.length === 0 && (
              <p className="px-5 py-10 text-center text-sm text-clinic-500">
                No conversations match the selected filters.
              </p>
            )}

            <div
              ref={ref}
              className="mt-3 flex h-10 w-full items-center justify-center"
            >
              {listLoading && <ClipLoader color={"#0891b2"} size={30} />}
            </div>
          </div>
        </div>
        {convoLoading ? (
          <div className="col-span-8 flex h-full items-center justify-center">
            <ClipLoader color={"#64748b"} size={60} />
          </div>
        ) : (
          <div className="relative col-span-8 h-[82vh] overflow-hidden border-l border-t border-clinic-200 pb-2">
            {activeUser ? (
              <div className="flex h-[12%] w-full items-center justify-between border-b border-clinic-200 py-2 px-6 pl-6">
                <div className="flex items-center gap-x-3">
                  <img
                    src={woman}
                    className="h-9 w-9"
                    alt=""
                    aria-hidden="true"
                  />
                  <button
                    type="button"
                    onClick={handlePDataModal}
                    className={`flex items-center gap-x-1.5 rounded text-[15px] font-semibold text-clinic-900 underline decoration-clinic-300 underline-offset-2 hover:text-action-700 hover:decoration-action-400 ${focusRing}`}
                  >
                    <span>{activeUser}</span>
                    <MdOpenInNew aria-hidden="true" />
                  </button>
                </div>
                <p className="text-xs text-clinic-500">
                  <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.14em]">
                    Status:
                  </span>{" "}
                  <span className="font-medium text-clinic-700">
                    {conversationStatus}
                  </span>
                </p>
                <div className="flex items-center justify-center gap-x-2">
                  <button
                    type="button"
                    className={ghostBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      setMobile(userMobile);
                    }}
                  >
                    <span className="flex items-center gap-x-1.5">
                      <BsChatSquareTextFill aria-hidden="true" />
                      See all chats
                    </span>
                  </button>

                  {!getIsClosedStatus(activeConvoId) && !listLoading ? (
                    <button
                      type="button"
                      className={primaryBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCloseChat(activeConvoId);
                      }}
                    >
                      <span className="flex items-center gap-x-1.5">
                        <TiTickOutline aria-hidden="true" />
                        Close this chat
                      </span>
                    </button>
                  ) : null}
                </div>
              </div>
            ) : (
              <div className="flex h-full items-center justify-center bg-white">
                <span className="text-sm text-clinic-500">
                  No User Selected
                </span>
              </div>
            )}
            <div
              ref={scollRef}
              className="custom-scrollbar h-[calc(100%-64px)] w-full overflow-auto bg-white px-4"
            >
              {convo.map((item, i) => (
                <ChatBubble msg={item} key={i} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default QNAs;
